import "./SafeguardingPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Sustainability from "./sections/Sustainability";
import SafeguardingPolicyDetails from "./sections/SafeguardingPolicyDetails";
import Footer from "@/reusable_sections/Footer";
export default function SafeguardingPolicyPage() {
  return <div>
      <Header />
      <Sustainability />
      <SafeguardingPolicyDetails />
      <Footer />
    </div>;
}